var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephoneLittleSheep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.89,.51c.68-.68,1.79-.68,2.47,0,.05,.05,.1,.1,.14,.16l1.8,2.31c.33,.42,.45,.97,.32,1.49l-.55,2.19c-.06,.23,.01,.47,.18,.64l2.46,2.46c.17,.17,.41,.24,.64,.18l2.19-.55c.52-.13,1.07-.01,1.49,.31l2.31,1.79c.83,.65,.91,1.87,.16,2.61l-1.03,1.03c-.74,.74-1.85,1.07-2.88,.7-2.64-.93-5.03-2.44-7.01-4.42C2.59,9.46,1.08,7.06,.15,4.42-.21,3.39,.11,2.28,.85,1.54L1.89,.51Z",
    style: {
      fill: "#939393",
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneLittleSheep);
export default __webpack_public_path__ + "static/media/TelephoneLittleSheep.964009194654feeede32fdbc97d87129.svg";
export { ForwardRef as ReactComponent };